import { render, staticRenderFns } from "./CreateTermsPage.vue?vue&type=template&id=6a0c7dd4&scoped=true&"
import script from "./CreateTermsPage.vue?vue&type=script&lang=js&"
export * from "./CreateTermsPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateTermsPage.vue?vue&type=style&index=0&id=6a0c7dd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c7dd4",
  null
  
)

export default component.exports